<script setup lang="ts">const className = __MACROS_toRef(__props, "class");

import { toRef as __MACROS_toRef } from "vue";
import { PopoverArrow, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from "reka-ui";

import { useWindow } from "@/hooks/use-window";

const window = useWindow();

withDefaults(defineProps<{
  class?: string;
  align?: "center" | "start" | "end";
  side?: "right" | "bottom" | "top";
}>(), { align: "start",side: "right", })
defineSlots<Record<"default" | "trigger", unknown>>();
</script>
<template>
  <PopoverRoot>
    <PopoverTrigger as-child>
      <slot name="trigger" />
    </PopoverTrigger>
    <PopoverPortal :to="window.document.body">
      <PopoverContent
        :side="side"
        :align="align"
        avoid-collisions
        :class="className"
        class="tw-b-r tw-z-[1000000] tw-flex tw-max-h-[calc(var(--reka-popover-content-available-height)-1rem)] tw-min-w-72 tw-flex-col tw-gap-2 tw-overflow-y-auto tw-rounded-lg tw-bg-white tw-p-3 tw-text-gray-800 tw-shadow"
        :align-offset="5"
        :side-offset="5"
        :arrow-padding="10"
        :collision-padding="10"
      >
        <PopoverArrow class="tw-fill-current" />
        <slot name="default" />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>
